// userSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";

const initialState = {
	style: "pixelArt",
	settings: { seed: "Aneka" },
};

const characterSlice = createSlice({
	name: "character",
	initialState,
	reducers: {
		overwriteCharacter: (state, action) => {
			state = action.payload;
		},
		setStyle: (state, action) => {
			state.style = action.payload;
		},
		setSettings: (state, action) => {
			state.settings = action.payload;
		},
	},
});

export const {
	overwriteCharacter,
	clearCharacter,
	setSettings,
	setSettingValue,
	setStyle,
} = characterSlice.actions;

export const selectCharacter = (state) => state.character;

export default characterSlice.reducer;
